import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, IsString, ValidateNested } from 'class-validator';
import { SubdivisionBuilderSupervisorBatchInterface } from '../interfaces/subdivision-builder-supervisor-batch.interface';
import { SubdivisionBuilderSupervisorInterface } from '../interfaces/subdivision-builder-supervisor.interface';
import { SubdivisionBuilderSupervisorCreateDto } from './subdivision-builder-supervisor-create.dto';
import { SubdivisionBuilderSupervisorUpdateDto } from './subdivision-builder-supervisor-update.dto';

export class SubdivisionBuilderSupervisorBatchDto
  implements SubdivisionBuilderSupervisorBatchInterface
{
  @ApiPropertyOptional({
    type: () => SubdivisionBuilderSupervisorCreateDto,
    title: 'SubdivisionBuilderSupervisor',
    nullable: true,
    isArray: true,
    description: 'Insert bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => SubdivisionBuilderSupervisorCreateDto)
  insert!: SubdivisionBuilderSupervisorCreateDto[];

  @ApiPropertyOptional({
    type: () => SubdivisionBuilderSupervisorUpdateDto,
    title: 'SubdivisionBuilderSupervisor',
    nullable: true,
    isArray: true,
    description: 'Update bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => SubdivisionBuilderSupervisorUpdateDto)
  update!: SubdivisionBuilderSupervisorUpdateDto[];

  @ApiProperty({
    type: () => String,
    nullable: true,
    isArray: true,
    title: 'Delete Bulk',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  delete!: SubdivisionBuilderSupervisorInterface['id'][];
}
